/**
 * DonateFooter — a visible, persistent link asking visitors to donate to
 * the Internet Archive. Constitutional (Principle III + FR-012).
 */
export function DonateFooter() {
  return (
    <footer className="app-footer">
      <span>
        Every video streams directly from the Internet Archive. Night Light is a
        thin love-letter to their work.
      </span>
      <a href="https://archive.org/donate" target="_blank" rel="noreferrer">
        Donate to archive.org →
      </a>
    </footer>
  );
}
